import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material/styles';

export const classes: {
    defaultProps?: ComponentsProps['MuiTableCell'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiTableCell'];
    variants?: ComponentsVariants['MuiTableCell'];
} = {
    styleOverrides: {
        head: {
            color: '#6F7377',
            fontSize: 12,
            height: 34, // --row-h-head
            padding: '4px 16px 0px 24px',
            fontWeight: 400,
            borderBottomColor: '#A7A9AC',
        },
        root: {
            padding: '6px 16px 6px 24px',
            borderBottom: '1px solid #EEEFEF',
        },
        body: {
            fontSize: 12.5, // dense table body
            lineHeight: '145%',
            fontWeight: 400,
            height: 38, // --row-h
        },
        footer: {
            border: 'none',
        },
    },
};
